export default Object.freeze({
  log: {},
  reportLinks: {}
});
